<template>
  <div>
    <el-dialog
      :title="dialogTitle"
      :visible="dialogCategory"
      width="750px"
      top="3vh"
      :modal="true"
      :append-to-body="true"
      :before-close="resetValidation('category')"
      @close="close"
      @open="open"
    >
      <el-form ref="category" :model="category" label-position="top">
        <el-form-item label="Name" prop="name" required>
          <el-input type="text" v-model="category.name" clearable />
        </el-form-item>
        <el-form-item label="Position" prop="position" required>
          <el-input type="number" v-model="category.position" clearable />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button
          type="primary"
          size="mini"
          :loading="loading"
          @click="submit()"
        >
          Save
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'

export default {
  data() {
    return {
      url: process.env.VUE_APP_ADMIN_API_URL,
      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
    }
  },

  computed: {
    dialogTitle: function() {
      if (typeof this.category.id !== 'undefined' && this.category.id !== null)
        return 'Edit Category'
      else {
        return 'Insert Category'
      }
    },
    ...mapState('faq', ['loading', 'category', 'dialogCategory'])
  },

  methods: {
    ...mapActions('faq', ['updateCategory', 'insertCategory']),
    ...mapMutations('faq', ['setDialogCategory']),

    submit() {
      if (typeof this.category.id !== 'undefined' && this.category.id !== null)
        this.updateCategory(this.category.id)
      else this.insertCategory()
    },

    close() {
      this.setDialogCategory(false)
    },

    open() {
      if (this.category.id == null) {
        setTimeout(() => {
          this.resetValidation('category')
        }, 5)
      }
    },

    resetValidation(formName) {
      if (typeof this.$refs[formName] != 'undefined') {
        this.$refs[formName].fields.find(f => f.prop == 'name').clearValidate()
        this.$refs[formName].fields
          .find(f => f.prop == 'position')
          .clearValidate()
      }
    }
  }
}
</script>
